var f = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var k = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var m = (t, o, e) => o in t ? f(t, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[o] = e, i = (t, o) => {
  for (var e in o || (o = {}))
    k.call(o, e) && m(t, e, o[e]);
  if (r)
    for (var e of r(o))
      s.call(o, e) && m(t, e, o[e]);
  return t;
}, a = (t, o) => p(t, c(o));
import g, { forwardRef as n } from "react";
import d from "../lib/IconBase.mjs";
import l from "../defs/TiktokLogo.mjs";
const w = n((t, o) => /* @__PURE__ */ g.createElement(d, a(i({ ref: o }, t), { weights: l })));
w.displayName = "TiktokLogo";
export {
  w as TiktokLogo
};
